module.exports = __webpack_public_path__ + "img/refuse.076a23c1.svg";